module.exports = __webpack_public_path__ + "img/1.983b9da5.png";